import {checkIfRankSkinNewArtReady, RANK_SKIN_OLD_ART_LEAGUES} from '../../configs/rankSkins';
import {getFactionIconPath} from './getFactionIconPath';

export const getFactionRankIconPath = (factionId, rank) => {
  if (!factionId || !rank) {
    return '/img/other/strategikon_bust.png';
  }

  // Иконки нового арта — в ranks_new_icons (см. getFactionRankImagePath)
  if (checkIfRankSkinNewArtReady(rank, factionId)) {
    return `/img/factions/ranks_new_icons/icon_${factionId}_${rank}.jpg`;
  }
  if (RANK_SKIN_OLD_ART_LEAGUES.includes(rank)) {
    return `/img/factions/ranks_icons/icon_${factionId}_${rank}.png`;
  }
  return getFactionIconPath(factionId);
};
